import { toggleClass, removeClass, addClass } from '../../utils';

import popoverPosition from './popoverPosition';

const DELAY = 200;

export default function handle(extension, { $button, $selector, SELECTOR_OPEN_CN }) {
   extension.addEvent($button, 'click', toggle);

   let timerId = 0;

   extension.addEvent(extension.getElement(), 'mouseleave', hide);

   extension.addEvent($button, 'mouseenter', () => timerId = setTimeout(show, DELAY) );

   function toggle() {
      toggleClass($selector, SELECTOR_OPEN_CN);
      popoverPosition(extension.player, $button, $selector);
   }

   function hide() {
      clearTimeout(timerId);
      removeClass($selector, SELECTOR_OPEN_CN);
   }

   function show() {
      addClass($selector, SELECTOR_OPEN_CN);
      popoverPosition(extension.player, $button, $selector);
   }
}
